export const TableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: "#",
          type: "text",
          key: "rownum",
        },
        {
          title: "Organización",
          type: "custom-html",
          key: "org",
          modifier: (item) => {
            return item ? item.value : "Matriz";
          },
        },
        {
          title: "Categoría",
          type: "custom-html",
          key: "level_3",
          modifier: (value) => {
            return value ? value.value : "";
          },
        },
        {
          title: "Campo de ensayo",
          type: "custom-html",
          key: "level_4",
          modifier: (value) => {
            return value ? value.value: "";
          },
        },
        {
          title: "PRODUCTO O MATERIAL A MUESTREAR",
          type: "custom-html",
          key: "product",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "PROCEDIMIENTO DE MUESTREO (Procedimiento normalizado y procedimiento interno, si aplica)",
          type: "custom-html",
          key: "process",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "MÉTODO DE REFERENCIA DEL MUESTREO (revisión/edición) (5)",
          type: "custom-html",
          key: "method",
          modifier: (value) => {
            return value;
          },
        },
        {
          title:
            "MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o método de referencia con su revisión/edición)",
          type: "custom-html",
          key: "test_methods",
          modifier: (value) => {
            return value;
          },
        },
        {
          title: "Justificación",
          type: "custom-html",
          key: "observation",
          modifier: (value) => {
            if (value) {
              return `<i style="color:red">${value}</i>`;
            }
          },
        },
      ],
      actionObj: {
        title: "Acción",
        type: "action",
      },
      columnStatus: {
        title: "Estado",
        type: "custom-html",
        key: "status",
        modifier: (item) => {
          if (item) {
            return `<span class="badge badge-sm badge-pill badge-success">${item.name}</span>`;
          } else {
            return '<span class="badge badge-sm badge-pill badge-primary">Alcance con el que inició el proceso</span>';
          }
        },
      },
    };
  },
};
